// import React, { useEffect, useState } from "react";
// import { createAdmin,  } from "../../../services/superAdminService";

// import {
//   getCountries,
//    getStatesByCountry,
//    getCitiesByState,
// } from '../../../services/apiService';

// const CreateAdmin = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     password: "",
//     role: "admin",
//     country: "",
//     state: "",
//     city: "",
//     address: "",
//     dateOfBirth: "",
//     canDirectPost: false,
//     canDirectGoLive: false,
//     profileImageFile: null,
//   });

//   const [countries, setCountries] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         const res = await getCountries();
//         setCountries(res.data || []);
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     fetchCountries();
//   }, []);

//   useEffect(() => {
//     if (form.country) {
//       const fetchStates = async () => {
//         const res = await  getStatesByCountry(form.country);
//         setStates(res.data || []);
//       };
//       fetchStates();
//     } else {
//       setStates([]);
//       setCities([]);
//       setForm(f => ({ ...f, state: "", city: "" }));
//     }
//   }, [form.country]);

//   useEffect(() => {
//     if (form.state) {
//       const fetchCities = async () => {
//         const res = await  getCitiesByState(form.state);
//         setCities(res.data || []);
//       };
//       fetchCities();
//     } else {
//       setCities([]);
//       setForm(f => ({ ...f, city: "" }));
//     }
//   }, [form.state]);

//   const handleChange = (e) => {
//     const { name, value, type, checked, files } = e.target;
//     if (type === "checkbox") {
//       setForm({ ...form, [name]: checked });
//     } else if (type === "file") {
//       setForm({ ...form, [name]: files[0] });
//     } else {
//       setForm({ ...form, [name]: value });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const formData = new FormData();
//       Object.keys(form).forEach((key) => {
//         if (form[key] !== null && form[key] !== "") {
//           formData.append(key, form[key]);
//         }
//       });

//       const res = await createAdmin(formData);
//       alert(`Admin created successfully: ${res.data.name}`);
//       setForm({
//         name: "",
//         email: "",
//         password: "",
//         role: "admin",
//         country: "",
//         state: "",
//         city: "",
//         address: "",
//         dateOfBirth: "",
//         canDirectPost: false,
//         canDirectGoLive: false,
//         profileImageFile: null,
//       });
//     } catch (error) {
//       console.error(error);
//       alert(error.response?.data?.message || "Error creating admin");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} style={{ maxWidth: 600, margin: "0 auto" }}>
//       <h2>Create Admin</h2>

//       <input name="name" placeholder="Name" value={form.name} onChange={handleChange} required />
//       <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
//       <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required />

//       <input name="address" placeholder="Address" value={form.address} onChange={handleChange} />
//       <input name="dateOfBirth" type="date" value={form.dateOfBirth} onChange={handleChange} />

//       <select name="country" value={form.country} onChange={handleChange}>
//         <option value="">Select Country</option>
//         {countries.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
//       </select>

//       <select name="state" value={form.state} onChange={handleChange}>
//         <option value="">Select State</option>
//         {states.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
//       </select>

//       <select name="city" value={form.city} onChange={handleChange}>
//         <option value="">Select City</option>
//         {cities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
//       </select>

//       <label>
//         Can Direct Post:
//         <input type="checkbox" name="canDirectPost" checked={form.canDirectPost} onChange={handleChange} />
//       </label>

//       <label>
//         Can Direct Go Live:
//         <input type="checkbox" name="canDirectGoLive" checked={form.canDirectGoLive} onChange={handleChange} />
//       </label>

//       <input type="file" name="profileImageFile" onChange={handleChange} />

//       <button type="submit" disabled={loading}>
//         {loading ? "Creating..." : "Create Admin"}
//       </button>
//     </form>
//   );
// };

// export default CreateAdmin;



import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  Switch,
  FormControlLabel,
  MenuItem,
} from '@mui/material';

import { createAdmin,  } from "../../../services/superAdminService";
import {
  getCountries,
  getStatesByCountry,
  getCitiesByState,
} from '../../../services/apiService';

const CreateAdmin = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    address: '',
    dateOfBirth: '',
    country: '',
    state: '',
    city: '',
    role: 'admin',
    profileImageFile: null,
    canDirectPost: false,
    canDirectGoLive: false,
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await getCountries();
        setCountries(res.data);
      } catch (err) {
        console.error('Error fetching countries:', err);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (formData.country) {
      getStatesByCountry(formData.country)
        .then((res) => setStates(res.data))
        .catch((err) => console.error('Error fetching states:', err));
    } else {
      setStates([]);
    }
  }, [formData.country]);

  useEffect(() => {
    if (formData.state) {
      getCitiesByState(formData.state)
        .then((res) => setCities(res.data))
        .catch((err) => console.error('Error fetching cities:', err));
    } else {
      setCities([]);
    }
  }, [formData.state]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else if (type === 'file') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSubmit = new FormData();
      Object.keys(formData).forEach((key) => {
        dataToSubmit.append(key, formData[key]);
      });

      const res = await createAdmin(dataToSubmit);
      alert('Reporter added successfully!');
      setFormData({
        name: '', email: '', password: '', address: '',
        dateOfBirth: '', country: '', state: '', city: '',
        profileImageFile: null, canDirectPost: false, canDirectGoLive: false
      });
    } catch (err) {
      console.error('Error adding reporter:', err);
      alert('Failed to add reporter.');
    }
  };

  return (
    <Paper sx={{ padding: 3, maxWidth: 800, margin: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Add Reporter
      </Typography>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth name="name" label="Name"
              value={formData.name} onChange={handleChange} required
            />
          </Grid>
           <Grid item xs={12} sm={6}>
            <TextField
              fullWidth name="role" label="role"
              value={formData.role} onChange={handleChange} required disabled
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth name="email" label="Email"
              value={formData.email} onChange={handleChange} required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth type="password" name="password" label="Password"
              value={formData.password} onChange={handleChange} required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth name="address" label="Address"
              value={formData.address} onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth type="date" name="dateOfBirth"
              label="Date of Birth" InputLabelProps={{ shrink: true }}
              value={formData.dateOfBirth} onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth select label="Country" name="country"
              value={formData.country} onChange={handleChange} required
            >
              {countries.map((c) => (
                <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth select label="State" name="state"
              value={formData.state} onChange={handleChange} required
              disabled={!formData.country}
            >
              {states.map((s) => (
                <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth select label="City" name="city"
              value={formData.city} onChange={handleChange} required
              disabled={!formData.state}
            >
              {cities.map((c) => (
                <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth type="file" name="profileImageFile"
              onChange={handleChange} inputProps={{ accept: 'image/*' }}
            />
          </Grid>

          

          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Add admin
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default CreateAdmin;











